import dayjs from 'dayjs'

export default {
  time2MCTime (time) {
    return dayjs(time).subtract(6, 'hour')
  },
  MCTime2Time (mctime) {
    return dayjs(mctime).add(6, 'hour')
  },
  downloadURL (href, name) {
    console.log(href);
    let eleLink = document.createElement('a')
    eleLink.download = name
    eleLink.href = href
    eleLink.click()
    eleLink.remove()
  },
  deepClone (obj) {
    let _obj = JSON.stringify(obj)
    let objClone = JSON.parse(_obj)
    return objClone
  },
  /**
     * 使用span标签包裹内容，然后计算span的宽度 width： px
     */
  getTextWidth (str) {
    return str.length * 12
    // 使用下面方法在渲染时会十分缓慢
    /*
    let width = 0
    let html = document.createElement('span')
    html.innerText = str
    html.className = 'getTextWidth'
    document.querySelector('body').appendChild(html)
    width = document.querySelector('.getTextWidth').offsetWidth
    document.querySelector('.getTextWidth').remove()
    return width
    */
  },
  getTextMaxLength (arr) {
    return arr.reduce((acc, item) => {
      if (item) {
        let calcLen = this.getTextWidth(item)
        if (acc < calcLen) {
          acc = calcLen
        }
      }
      return acc
    }, 0)
  },
  divideZero (a, b) {
    if (Math.abs(b) < 1e-10) {
      return 0
    }
    return a / b
  },
  null2Zero (price) {
    if (price) {
      return price
    }
    return 0
  }
}



// WEBPACK FOOTER //
// ./src/common/utils.js